import { MIN_RATING_AVERAGE, MIN_RATING_COUNT } from '@/modules/rating-detail/constants/Rating';
import { NumberFormatter } from '@/shared/helper/NumberFormatter';

export const RatingHelper = () => {
  const getRatingLabel = (ratingAverage: number): string => {
    if (Math.ceil(ratingAverage) === 5) {
      return 'Sehr gut';
    }
    if (Math.ceil(ratingAverage) === 4) {
      return 'Gut';
    }
    return '';
  };

  const showRatingBadge = (ratingCount: number, ratingAverage: number): boolean => {
    return Math.round(ratingAverage) >= MIN_RATING_AVERAGE && ratingCount >= MIN_RATING_COUNT;
  };

  const getNumberOfRatingsLabel = (ratingCount: number): string => {
    return ratingCount === 1 ? '1 Bewertung' : `${NumberFormatter().formatCount(ratingCount)} Bewertungen`;
  };

  return {
    getRatingLabel,
    showRatingBadge,
    getNumberOfRatingsLabel,
  };
};
